/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#globoverviewdiv #hiw{top:2px;right:34px;font-size:inherit}#globoverviewdiv .csvfloat{top:1px}#globoverviewdiv .csvfloat img{opacity:.8}#globoverviewdiv .csvfloat img:hover{opacity:1}#globoverviewdiv table[align] td[valign] div{min-height:200px;margin:5px}"];
export { styles as styles };
